<script setup lang="ts">
import { sortBy } from "lodash-es";
import { computed } from "vue";

import ReporterItemTooltip from "@/components/search/tooltips/ReporterItemTooltip.vue";
import type { AuthUser } from "@/model/user";
import { useSearchMenuStore } from "@/store/search/searchMenu";
import { useUserStore } from "@/store/user";

import SearchDropdown from "./SearchDropdown.vue";
import SelectUser from "./internal/SelectUser.vue";

const store = useSearchMenuStore();
const currentUser = useUserStore().currentUser;

const selection = computed({
  get: () => store.selectedReporters,
  set: (values: Array<{ id: string }>) => {
    store.selectedReporterIds = new Set(values.map((val) => val.id));
  },
});

/**
 * Returns all users currently assigned to any card on this board,
 * with the current user listed first
 */
const currentBoardReporters = computed(() => {
  const users = store.allReporters.filter((user) => user.almMapping !== "alm-only");
  const currentUserFirst = (user: AuthUser) => user.id !== currentUser?.id;

  return sortBy(users, [currentUserFirst]);
});
</script>

<template>
  <SearchDropdown
    name="reporter"
    icon="persona/reporter"
    label-key="general.reporters"
    :selected="selection.length > 0"
  >
    <template #tooltip>
      <ReporterItemTooltip :reporters="selection" />
    </template>
    <SelectUser
      v-model="selection"
      :values="currentBoardReporters"
      :header="$t('general.reporters')"
    />
  </SearchDropdown>
</template>
